module.exports = function (done, value) {
  return { value: value, done: !!done };
};



//////////////////
// WEBPACK FOOTER
// /data/app/rdc-next/~/core-js/modules/_iter-step.js
// module id = 269
// module chunks = 48 49 50 51